import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Typography } from "antd";

import BackButton from "components/BackButton";
import StoreEdit from "components/Store/Edit";
import { createStoreRequest } from "providers/StoreProvider/slice";
import { STORE_TYPE } from "utils/constants";
import Helper from "utils/helpers";
import "./styles.less";
import moment from "moment/moment";

const context = {
  [STORE_TYPE.CAR_AND_OLD_STUFF]: {
    title: "Tạo cửa hàng",
    path: "/car-and-old-stuff",
  },
  [STORE_TYPE.TRAVEL]: {
    title: "Đăng bài",
    path: "/travel",
  },
  [STORE_TYPE.SHIPPER]: {
    title: "Tạo vận chuyển",
    path: "/shipper",
  },
  [STORE_TYPE.ENTERTAINMENT]: {
    title: "Tạo giải trí",
    path: "/entertainment",
  },
};

const StoreCreate = ({ storeType }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeContext = context[storeType];

  const handleSubmit = async (values) => {
    console.log("[DEBUG] Formik values on create:", values);
    const latLng = await Helper.getLatLng(values.address, {
      lng: values.lng,
      lat: values.lat,
    });

    // Build a new payload object (do not mutate values directly)
    const payload = {
      ...values,
      longitude: latLng.lng,
      latitude: latLng.lat,
      hasPromotion: values.isPromotionActive,
    };

    // Handle custom time for promotion
    if (
      storeType === STORE_TYPE.ENTERTAINMENT &&
      (payload.discountCondition === "CUSTOM" || payload.discountCondition?.value === "CUSTOM") &&
      payload.start &&
      payload.end
    ) {
      payload.openningTimeData = [{ start: payload.start, end: payload.end }];
      delete payload.customDiscountCondition;
    } else if (payload.start) {
      payload.customDiscountCondition = {
        start: payload.start,
        end: payload.end,
      };
    }

    if (payload.hasPromotion) {
      payload.discountCondition = payload.discountCondition ?? null;
      payload.discountPercentage = payload.discountPercentage ?? null;
    }

    dispatch(
      createStoreRequest({
        type: storeType,
        data: payload,
      })
    ).then((data) => {
      navigate(`${storeContext.path}/${data._id}`, {
        state: { canGoBack: true },
        replace: true,
      });
    });
  };
  return (
    <div className="store-detail-wrapper">
      <Row className="store-detail-header" justify="start" align="middle">
        <BackButton />
        <Typography.Title level={4}>{storeContext.title}</Typography.Title>
      </Row>
      <div className="detail-wrapper">
        <StoreEdit
          initialValues={{ isPromotionActive: false }}
          storeType={storeType}
          onSubmit={handleSubmit}
          isCreating
        />
      </div>
    </div>
  );
};

export default StoreCreate;
